module.exports = __webpack_public_path__ + "static/media/greySpinner.e975d37a.gif";